import { NgIf } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Inject,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogModule } from '@angular/material/legacy-dialog';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

export interface VideoPopupData {
  title: string;
  videoUrl: string;
}

@Component({
  selector: 'ten-video-popup',
  templateUrl: './video-popup.component.html',
  styleUrls: ['./video-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [MatLegacyDialogModule, NgIf, MatLegacyButtonModule, MatIconModule],
})
export class VideoPopupComponent implements AfterViewInit, OnDestroy {
  public vimeoUrl: SafeUrl;
  public youtubeVideoId: string;
  private player: YT.Player;

  @ViewChild('videoWrapper', { static: false })
  public videoWrapper: ElementRef;

  constructor(@Inject(MAT_DIALOG_DATA) public popupData: VideoPopupData, private domSanitizer: DomSanitizer) {
    this.youtubeVideoId = this.getYoutubeVideoId(popupData.videoUrl);

    if (!this.youtubeVideoId) {
      const vimeoVideoId = this.getVimeoVideoId(popupData.videoUrl);

      if (vimeoVideoId) {
        this.vimeoUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(
          `https://player.vimeo.com/video/${vimeoVideoId}?autoplay=1&controls=1`
        );
      }
    }
  }

  public ngAfterViewInit() {
    if (this.youtubeVideoId) {
      this.player = new YT.Player(this.videoWrapper.nativeElement, {
        videoId: this.youtubeVideoId,
        playerVars: {
          playsinline: 1,
          autoplay: 1,
          rel: 0,
          controls: 1,
          modestbranding: 1,
          showinfo: 0,
        },
      });
    }
  }

  public ngOnDestroy() {
    this.player?.destroy();
  }

  private getYoutubeVideoId(url: string): string {
    const youtubeMatches = url?.match(/^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/);

    return youtubeMatches?.length === 3 ? youtubeMatches[2] : null;
  }

  private getVimeoVideoId(url: string): string {
    const vimeoMatches = url?.match(/(vimeo(pro)?\.com)\/(?:[^\d]+)?(\d+)\??(.*)?$/);

    return vimeoMatches?.length === 5 ? vimeoMatches[3] : null;
  }
}
